import { HiWifi } from "react-icons/hi2";
import { useTV } from "../../hooks/useTV";
import { useState } from "react";
import { buttonIds } from "../../config/buttonIds";

const WifiButton = () => {
  const { isTv } = useTV();
  const [isFocused, setIsFocused] = useState(false);

  const goToWifiSettingsPageOnExpoApp = () => {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        action: "open-wifi-settings",
      })
    );
  };

  const handleKeyDown = (e) => {
    if (isTv && e.key === "ArrowLeft") {
      // Focus the GetStarted button
      const getStartedButton = document.getElementById(
        buttonIds.getStartedButton
      );
      if (getStartedButton) {
        getStartedButton.focus();
      }
    } else if (isTv && e.key === "ArrowDown") {
      // Focus the GetStarted button
      const getStartedButton = document.getElementById(
        buttonIds.getStartedButton
      );
      if (getStartedButton) {
        getStartedButton.click();
      }
    }
  };

  return (
    <button
      id="wifi-button"
      style={
        isTv
          ? {
              width: "auto",
              height: isTv ? "100px" : "80px",
              background: "white",
              borderRadius: "20px",
              paddingLeft: "30px",
              paddingRight: "30px",
              fontSize: "30px",
              position: "absolute",
              right: "5%",
              top: "5%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 5,
              fontFamily: "Lato",
              border: isFocused ? "2px solid blue" : "none",
            }
          : {
              width: "auto",
              height: "80px",
              background: "white",
              borderRadius: "20px",
              paddingLeft: "20px",
              paddingRight: "20px",
              fontSize: "25px",
              position: "absolute",
              right: "5%",
              top: "5%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 5,
              fontFamily: "Lato",
              border: "none",
            }
      }
      onClick={goToWifiSettingsPageOnExpoApp}
      onKeyDown={handleKeyDown}
      onFocus={() => {
        setIsFocused(true);
        document.getElementById(buttonIds.getStartedButton).click();
      }}
      onBlur={() => setIsFocused(false)}
    >
      <HiWifi
        style={{ fontSize: isTv ? "40px" : "30px", marginRight: "10px" }}
        color={"blue"}
      />
      Wifi Settings
    </button>
  );
};

export default WifiButton;
